export const wrapper = {
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	width: '100%',
};

export const colorBlock = (bgColor: string) => ({
	height: { xs: '80px', md: '100px' },
	backgroundColor: bgColor,
	width: {
		md: '100%', // applies width only on md and up
	},
	flexGrow: 1, // Let items grow to fill space equally
    // flexShrink: 0, // Prevent shrinking
	// ✨ These are the key properties for centering the image ✨
    display: 'flex',          // Make the box a flex container
    justifyContent: 'center', // Center content horizontally
    alignItems: 'center', // Center content vertically
});
